export default __webpack_public_path__ + "be0d6ae32b9ebe5630e827b04102fab8.png";